import {
  UPDATE_CONTRIBUTOR_IMAGE,
  ADD_CONTRIBUTOR_IMAGE,
  SET_CONTRIBUTOR,
} from '../constants/actions'

const initState = {}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_CONTRIBUTOR:
      return action.contributor
    case UPDATE_CONTRIBUTOR_IMAGE:
    case ADD_CONTRIBUTOR_IMAGE:
      return {
        ...state,
        mainImageId: action.mainImageId,
        mainImageLastChecked: action.mainImageLastChecked,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contributor.js